import { Controller } from '@hotwired/stimulus';

/**
 * Inline Label Controller
 *
 * Handles inline editing of contract labels with character counter,
 * keyboard shortcuts (Enter to submit, Escape to cancel),
 * and highlight flash on successful save.
 */
export default class extends Controller {
  static targets = ['input', 'counter'];
  static values = {
    saved: { type: Boolean, default: false },
  };

  connect() {
    if (this.hasInputTarget) {
      this.inputTarget.focus();
      this.updateCounter();
    }

    if (this.savedValue) {
      this.#highlightFlash();
    }
  }

  /**
   * Updates the character counter display based on current input length.
   */
  updateCounter() {
    if (!this.hasCounterTarget || !this.hasInputTarget) return;

    const length = this.inputTarget.value.length;
    this.counterTarget.textContent = `${length}/80`;
  }

  /**
   * Handles keyboard events: Enter submits, Escape cancels.
   * @param {KeyboardEvent} event
   */
  handleKeydown(event) {
    if (event.key === 'Enter') {
      event.preventDefault();
      this.element.requestSubmit();
    } else if (event.key === 'Escape') {
      event.preventDefault();
      this.#cancel();
    }
  }

  /**
   * Triggers a brief highlight flash animation on the controller element.
   */
  #highlightFlash() {
    this.element.classList.add('animate-label-highlight');
    this.element.addEventListener(
      'animationend',
      () => {
        this.element.classList.remove('animate-label-highlight');
      },
      { once: true }
    );
  }

  /**
   * Cancels inline editing by clicking the cancel link.
   */
  #cancel() {
    const cancelLink = this.element.querySelector('a[data-turbo-frame]');
    if (cancelLink) {
      cancelLink.click();
    }
  }
}
